/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';
import SolutionCatalog from '@models/SolutionCatalog';
import Question from '@models/Question';
import { learnerDoubtsAndSolutionsTypes } from '@actions-constants/index';
import paginateAction from '@utils/paginateAction';
import { paginatorListSchema } from '../schemas';

const getCatalogueTypes = (key, resetWithoutEmpty) => (next) => ({
  type: learnerDoubtsAndSolutionsTypes.FETCH_CATALOGUE_TYPES,
  endpoint: next,
  method: 'get',
  key,
  resetWithoutEmpty,
  schema: paginatorListSchema,
  processData: (data) => {
    const newData = data;
    newData.results = data.results.map((catalog) =>
      SolutionCatalog.getEntityData(catalog)
    );
    return newData;
  }
});

export const fetchCatalogueTypes = (
  goalUID,
  type = 1,
  nextPage,
  resetWithoutEmpty = false
) =>
  paginateAction(
    `v1/catalogues/browse/all/?goal_uid=${goalUID}&offset=0&limit=100&type=${type}`,
    getCatalogueTypes(`${goalUID}-${type}`, resetWithoutEmpty),
    'catalogueTypes',
    `${goalUID}-${type}`,
    resetWithoutEmpty
  )(nextPage);

const getCatalogueDetails = (ctlgUID) => (next) => ({
  type: learnerDoubtsAndSolutionsTypes.FETCH_CATALOGUE_DETAILS,
  endpoint: next,
  method: 'get',
  key: ctlgUID,
  resetWithoutEmpty: false,
  schema: paginatorListSchema,
  processData: (data) => {
    const newData = data;
    newData.results = data.results.map((ctlgItem) => {
      const nData = SolutionCatalog.getEntityData(ctlgItem);
      return nData;
    });
    return newData;
  }
});

/**
 * Fetch chapters/papers for a catalogue
 * @param {*} ctlgUID
 * @param {*} nextPage
 * @param {*} resetWithoutEmpty
 * @returns
 */
export const fetchCatalogueDetails = (
  ctlgUID,
  nextPage,
  resetWithoutEmpty = false
) =>
  paginateAction(
    `v1/catalogues/browse/entities/?catalogue_uid=${ctlgUID}&offset=0&limit=10`,
    getCatalogueDetails(ctlgUID, resetWithoutEmpty),
    'catalogueDetails',
    ctlgUID,
    resetWithoutEmpty
  )(nextPage);

const getCatalogueItemDetails = (ctlgItemUID) => (next) => ({
  type: learnerDoubtsAndSolutionsTypes.FETCH_QUESTIONS_LIST,
  endpoint: next,
  method: 'get',
  key: ctlgItemUID,
  resetWithoutEmpty: false,
  schema: paginatorListSchema,
  processData: (data) => {
    const newData = data;

    newData.results = data.results.map((sectionExercise) => {
      const nsectionExercise = { ...sectionExercise };
      nsectionExercise.subTitle = nsectionExercise.sub_title;
      nsectionExercise.questions = nsectionExercise.questions.map((question) =>
        Question.getEntityData(question)
      );

      return nsectionExercise;
    });
    return newData;
  }
});

export const fetchCatalogueItemDetails = (
  ctlgItemUID,
  nextPage,
  resetWithoutEmpty = false
) =>
  paginateAction(
    `v1/catalogues/browse/questions/?entity_uid=${ctlgItemUID}`,
    getCatalogueItemDetails(ctlgItemUID, resetWithoutEmpty),
    'catalogueItemDetails',
    ctlgItemUID,
    resetWithoutEmpty
  )(nextPage);

export const getCatalogueEntityDetails = (entityUID) => {
  return {
    type: learnerDoubtsAndSolutionsTypes.FETCH_CATALOGUE_ENTITY_DETAILS,
    endpoint: `v1/catalogues/browse/details/?catalogue_uid=${entityUID}`,
    method: 'get',
    entityUID,
    schema: new schema.Object({}),
    processData: (data) => {
      const nData = { ...data };
      nData.subTitles = nData.sub_titles;
      nData.supTitles = nData.sup_titles;
      return nData;
    }
  };
};

export const fetchQuestionMetaData = (questionUID) => ({
  type: learnerDoubtsAndSolutionsTypes.FETCH_QUESTION_META_DATA,
  endpoint: `v1/catalogues/browse/question_meta/?question_uid=${questionUID}`,
  method: 'get',
  questionUID
});
